import { render, staticRenderFns } from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=template&id=380b3527"
import script from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=script&lang=js"
export * from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=script&lang=js"
import style0 from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue?vue&type=style&index=0&id=380b3527&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports